<template>
    <div>
        <div class="row" @click="showCycleDetails()" @keyup.enter="showCycleDetails()">
            <div class="col-md-12">
                <span class="skill-title fake-link clickable">{{ cycle.name }}</span>
                <br />
                <div class="tw-truncate">{{ cycle.description }}</div>
                <div class="row color-grey">
                    <div class="col-md-6">
                        <span v-if="cycle.status === 'active'">
                            <i class="fal fa-repeat"></i>
                            <span class="l-default-margin-s">{{
                                $t(`goals.cycle.list.active`)
                            }}</span>
                        </span>
                        <span v-else-if="cycle.status === 'future'">
                            <i class="fal fa-calendar"></i>
                            <span class="l-default-margin-s">{{
                                $t(`goals.cycle.list.future`)
                            }}</span>
                        </span>
                        <span v-else-if="cycle.status === 'past'">
                            <i class="fal fa-calendar-times"></i>
                            <span class="l-default-margin-s">{{
                                $t(`goals.cycle.list.past`)
                            }}</span>
                        </span>
                        <i class="fal fa-user tw-ml-4"></i>
                        <span class="l-default-margin-s">
                            {{ cycle.createdBy.firstname }} {{ cycle.createdBy.lastname }}
                        </span>
                    </div>

                    <div
                        v-b-popover.hover.top="{
                            content: $t(`goals.cycle.list.timeline.plan`),
                        }"
                        class="col-md-2"
                    >
                        <i class="fal fa-pencil"></i>
                        <span class="l-default-margin-s">
                            {{ cycle.timeline.plan.date | moment("MMM DD, YYYY") }}
                        </span>
                    </div>

                    <div
                        v-b-popover.hover.top="{
                            content: $t(`goals.cycle.list.timeline.active`),
                        }"
                        class="col-md-2"
                    >
                        <i class="fal fa-rocket"></i>
                        <span class="l-default-margin-s">
                            {{ cycle.timeline.active.date | moment("MMM DD, YYYY") }}
                        </span>
                    </div>

                    <div
                        v-b-popover.hover.top="{
                            content: $t(`goals.cycle.list.timeline.end`),
                        }"
                        class="col-md-2"
                    >
                        <i class="fal fa-times"></i>
                        <span class="l-default-margin-s">
                            {{ cycle.timeline.end.date | moment("MMM DD, YYYY") }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <span class="hr-small"></span>
    </div>
</template>

<script>
export default {
    props: {
        cycle: {
            type: Object,
            required: true,
        },
    },
    methods: {
        showCycleDetails() {
            this.$router.push(`/goals/cycles/details/${this.cycle._id}`);
        },
    },
};
</script>

<style scoped></style>
